module.exports = __webpack_public_path__ + "static/media/default-amenity.dccaf129.png";